export default __webpack_public_path__ + "static/media/AzureDevOpsRepos.808ec743.svg";